/* eslint react-hooks/exhaustive-deps: 0 */

import { Alert, Card, Form, message, Modal, TablePaginationConfig } from "antd";
import type { FilterValue, SorterResult } from "antd/es/table/interface";
import { UITable } from "../../common/table";
import { useEffect, useState, useMemo, useRef } from "react";
import "./style.css";
import { page } from "../../../config/constants";
import { ReactComponent as PlayIcon } from "../../../assets/images/playBtn.svg";
import { SiteDeviceForm } from "./siteDeviceForm";
import { UIConfirmModal } from "../../common/confirmModal";
import { ModalButton } from "../../../config/enum";
import { useNavigate } from "react-router-dom";
import { Page } from "../../../routes/config";
import { useGetAllExecuteProcessQuery, useGetAllActiveProcessQuery, useStopActiveProcessMutation } from "../../../redux/services/processSlice";
import { useDispatch, useSelector } from "react-redux";
import { authStateSelector } from "../../../redux/features/auth/authSlice";
import {
  useCancelExecuteProcessMutation,
  useCreateProcessStateMutation,
  useGetAllDeviceByZoneQuery,
  useGetAllSiteQuery,
  useProcessExecuteMutation,
  useZoneySiteQuery,
} from "../../../redux/services/siteSlice";
import moment from "moment";
import UITooltip from "../../common/tooltip";
import search from "antd/lib/transfer/search";
import { setSyncedData, setStopButtonForRun, setProcessRunningModal } from "../../../redux/features/app/appSlice";
import { ProcessRunningModal } from "../../common/modal";
import {
  getFilterInfo,
  setFilterState,
} from "../../../redux/features/filter/filterSlice";

export const ExecuteProcess = (props: any) => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [deviceSelectModal, setDeviceSelectModal] = useState(false);
  const [total, setTotal] = useState(0);
  const filterState = useSelector(getFilterInfo);
  const currentURL = window.location.href;
  const [sort, setSort] = useState<any>({
    ...(currentURL == filterState?.url &&
      filterState?.sortBy && { sortBy: filterState?.sortBy }),
    ...(currentURL == filterState?.url &&
      filterState?.sortOrder && { sortOrder: filterState?.sortOrder }),
  });
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current:
      filterState?.page && currentURL == filterState?.url
        ? filterState?.page
        : page?.current,
    pageSize:
      filterState.limit && currentURL == filterState?.url
        ? filterState.limit
        : page?.pageSize,
    showSizeChanger: true,
  });
  const { tenantId, user } = useSelector(authStateSelector);
  const appState = useSelector((state: any) => state.app);
  const processRunningModal = appState?.processRunningModal || { visible: false, processName: "", deviceName: "", errorMessage: "" };
  const [loading, setLoading] = useState(true);
  const [tableData, setExecuteTableData] = useState<any>([]);
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState<any>({
    siteId: "",
    deviceId: "",
    zoneId: "",
  });
  // Memoize queryParams to prevent unnecessary re-renders
  const queryParams = useMemo(() => ({
    page: pagination.current,
    limit: pagination.pageSize,
    type: "ExecuteProcess",
    tenantId: tenantId,
    ...sort,
  }), [pagination.current, pagination.pageSize, tenantId, sort]);
  const [deviceInfo, setDeviceInfo] = useState({});
  // Track whether we showed "already exists" error (if true, don't cancel on modal close)
  const showedAlreadyExistsErrorRef = useRef(false);
  /** True after executeProcess unwrap() succeeds for this modal session — drives cancel-on-close & skips redundant cancel. */
  const executeSucceededForCurrentModalRef = useRef(false);
  
  const [canStartProcess, setCanStartProcess] = useState<boolean | null>(null);
  
  // These queries will automatically run when user data is available
  // RTK Query handles undefined parameters gracefully
  const getAllSiteByUserQuery = useGetAllSiteQuery(
    { userId: user?.userId, roleName: user?.roleName },
    { 
      refetchOnMountOrArgChange: true
    
    }
  );
  const getExecuteProcess = useGetAllExecuteProcessQuery(
    { queryParams, roleId: user?.roleId },
    { 
      refetchOnMountOrArgChange: true
    
    }
  );

  // Query to check active processes for validation
  const { data: activeProcessesData, refetch: refetchActiveProcesses } = useGetAllActiveProcessQuery(
    {
      queryParams: { page: 1, limit: 100, type: "ActiveProcess", tenantId },
      roleId: user?.roleId
    },
    {
      skip: !user?.roleId || !tenantId
    }
  );

  // Track user state changes
  useEffect(() => {
    // User state changed
  }, [user, tenantId]);

  useEffect(() => {
    if (getExecuteProcess?.isSuccess) {
      // Query successful, setting table data
      setLoading(false);
      // Removed refetch() call - it was causing infinite re-renders
      setExecuteTableData(getExecuteProcess?.data?.result);
      setTotal(getExecuteProcess?.data?.result?.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getExecuteProcess?.isSuccess, getExecuteProcess?.isError]);

  useEffect(() => {
    // Fulfilled timestamp changed
    setExecuteTableData(getExecuteProcess?.data?.result);
  }, [getExecuteProcess?.fulfilledTimeStamp]);

  useEffect(() => {
    if (getExecuteProcess?.isError) {
      console.error('ExecuteProcess: Query error occurred', {
        error: getExecuteProcess?.error,
        errorData: getExecuteProcess?.error?.data,
        errorMessage: getExecuteProcess?.error?.data?.message
      });
      message?.error({
        content: "No process to Execute",
        key: "notificationKey",
        className: "errorMessage",
        duration: 1,
      });
      setLoading(false);
    }
  }, [getExecuteProcess?.isError]);

  const navigate = useNavigate();

  // Ensure queries are called when user data becomes available
  useEffect(() => {
    const queryStatus = getExecuteProcess?.status;
    const siteQueryStatus = getAllSiteByUserQuery?.status;
    
    // If user data is available but queries haven't run, trigger them
    if (user?.roleId && queryParams && queryStatus === 'uninitialized') {
      getExecuteProcess?.refetch();
    }
    
    if (user?.userId && user?.roleName && siteQueryStatus === 'uninitialized') {
      getAllSiteByUserQuery?.refetch();
    }
    // Only depend on stable values, not query objects themselves
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userId, user?.roleId, user?.roleName, queryParams]);

  const getAllSiteOptions = () => {
    if (getAllSiteByUserQuery?.data?.result) {
      var temp: any[] = [];
      temp = getAllSiteByUserQuery?.data?.result?.map((site: any) => {
        return {
          text: site?.name,
          value: site?.siteId,
        };
      });
      return temp;
    } else if (getAllSiteByUserQuery?.data) {
      var temp2: any[] = [];
      temp2 = getAllSiteByUserQuery?.data?.map((site: any) => {
        return {
          text: site?.name,
          value: site?.siteId,
        };
      });
      return temp2;
    }
  };

  useEffect(() => {
    dispatch(
      setFilterState({
        page: queryParams?.page,
        limit: queryParams?.limit,
        sortBy: queryParams?.sortBy,
        sortOrder: queryParams?.sortOrder,
      })
    );
  }, [
    queryParams?.page,
    queryParams?.limit,
    queryParams?.sortBy,
    queryParams?.sortOrder,
  ]);

  const getAllDeviceBySiteQuery = useGetAllDeviceByZoneQuery(
    { zoneId: formValues?.zoneId },
    { refetchOnMountOrArgChange: true }
  );
  const [x, setX] = useState<any>({});
  useEffect(() => {
    const v = getAllDeviceBySiteQuery?.data?.result?.find(
      (x: any) => x?.deviceId === formValues?.deviceId
    );
    if (v) {
      setX(v);
    }
  }, [formValues?.deviceId]);

  const [zone, setzone] = useState<any>();

  useEffect(() => {
    if (x?.deviceSiteZoneProcess?.length) {
      setzone(x?.deviceSiteZoneProcess[0]);
    }
  }, [x]);

  const getAllDeviceOptions = () => {
    var temp: any[] = [];
    temp = getAllDeviceBySiteQuery?.data?.result?.map((device: any) => {
      return {
        text: `${device?.name} - [${device?.mac}]`,
        value: device?.deviceId,
      };
    });
    return temp;
  };

  const getAllZoneBySiteQuery = useZoneySiteQuery(
    {
      siteId: formValues?.siteId,
    },
    { refetchOnMountOrArgChange: true }
  );

  const getZoneBySIteOptions = () => {
    var temp: any[] = [];
    temp = getAllZoneBySiteQuery?.data?.result?.map((zone: any) => {
      return {
        text: `${zone?.name}`,
        value: zone?.zoneId,
      };
    });
    return temp;
  };

  const [executeProcess, setExecuteProcess] = useProcessExecuteMutation();
  const [cancelProcess, setCancelprocess] = useCancelExecuteProcessMutation();
  const [stateCreationMutation, { isError: isStateCreationError, isSuccess: isStateCreationSuccess, error: stateCreationError, reset: resetStateCreation }] = useCreateProcessStateMutation();
  const [stopActiveProcess] = useStopActiveProcessMutation();

  const onRowClick = (row: any) => {
    setSelectedRow(row);
    // Reset the flags when opening modal
    showedAlreadyExistsErrorRef.current = false;
    executeSucceededForCurrentModalRef.current = false;
    setCanStartProcess(null); // Reset flag when opening modal
    // Open modal directly - no API call
    setDeviceSelectModal(true);
  };

  const onPlayClick = (row: any) => {
    setSelectedRow(row);
    // Reset the flags when opening modal
    showedAlreadyExistsErrorRef.current = false;
    executeSucceededForCurrentModalRef.current = false;
    setCanStartProcess(null); // Reset flag when opening modal
    // Open modal directly - no API call
    setDeviceSelectModal(true);
  };

  // Handle executeProcess errors (when called from handleApply)
  // NOTE: Removed banner error - only show modal errors for specific cases
  // useEffect(() => {
  //   if (setExecuteProcess?.isError) {
  //     message.error({
  //       content: setExecuteProcess?.error?.data?.error?.message || "Failed to execute process. Please try again.",
  //       key: "notificationKey",
  //       className: "errorMessage",
  //       duration: 3,
  //     });
  //   }
  // }, [setExecuteProcess?.isError]);

  const onDeviceModalClose = () => {
    // If we showed "already exists" error, don't cancel the existing process
    // Just close the modal and preserve form fields (don't clear them)
    if (showedAlreadyExistsErrorRef.current) {
      // Already exists error was shown - closing modal
      showedAlreadyExistsErrorRef.current = false; // Reset flag
      setDeviceSelectModal(false); // Close modal immediately
      return; // Exit early - don't clear fields or call cancelProcess
    }
    
    // Only call cancel when execute succeeded for this open (avoids redundant traffic; backend is safe either way)
    const siteIdForCancel = formValues?.siteId || undefined;
    const zoneIdForCancel = zone?.zoneId || formValues?.zoneId || undefined;
    const cancelPayload: Record<string, unknown> = {
      processId: selectedRow?.processId,
      userId: user?.userId,
      type: "cancelBeforeDeviceSelection",
    };
    if (siteIdForCancel) {
      cancelPayload.siteId = siteIdForCancel;
    }
    if (zoneIdForCancel) {
      cancelPayload.zoneId = zoneIdForCancel;
    }

    if (executeSucceededForCurrentModalRef.current) {
      cancelProcess(cancelPayload);
      executeSucceededForCurrentModalRef.current = false;
    } else {
      setDeviceSelectModal(false);
    }

    // Clear form fields when dismissing the picker
    form.resetFields();
    setFormValues({
      siteId: "",
      zoneId: "",
      deviceId: "",
    });
    form.setFieldsValue({
      siteId: "",
      zoneId: "",
      deviceId: "",
    });
    setzone({});
  };

  useEffect(() => {
    if (setCancelprocess?.isSuccess) {
      const res: any = setCancelprocess.data;
      const apiMsg =
        res?.message ||
        res?.data?.message ||
        res?.result?.message ||
        res?.data?.result?.message;
      if (apiMsg && typeof apiMsg === "string") {
        message.info({
          content: apiMsg,
          key: "cancel-device-modal-msg",
          duration: 4,
          className: "successMessage",
        });
      }
      setDeviceSelectModal(false);
      form.resetFields();
    } else if (setCancelprocess?.isError) {
      setDeviceSelectModal(false);
    }
  }, [setCancelprocess?.isSuccess, setCancelprocess?.isError, setCancelprocess?.data, form]);

  const handleApply = async () => {
    // CRITICAL: Check active process table for any process with same device, site, and zone FIRST
    // Rule: If ANY process exists in the active process table (regardless of state) → block starting new process
    // Rule: If NO process exists in the active process table → allow starting (backend will clean up orphaned processes)
    
    // For Platform Admin, tenantId might be null/undefined, so get it from the selected device
    // Device tenantId can be in x.deviceSiteZoneProcess[0]?.tenantId or x.tenantId
    const deviceTenantId = x?.deviceSiteZoneProcess?.[0]?.tenantId || x?.tenantId;
    const finalTenantId = tenantId || deviceTenantId;
    
    if (!finalTenantId) {
      Modal.error({
        title: 'Tenant ID Required',
        content: 'Tenant ID is required. Please select a device with a valid tenant.',
        okText: 'OK',
        onOk: () => {
          setDeviceSelectModal(false);
        }
      });
      return;
    }
    
    // Refetch active processes to get the latest data from the table
    if (refetchActiveProcesses) {
      await refetchActiveProcesses();
    }
    const activeProcesses = activeProcessesData?.result || [];
    const targetZoneId = zone?.zoneId || formValues?.zoneId;
    
    // Check for existing process in the SAME site/zone/device only
    // Allow same processId to run in different sites/zones simultaneously
    const existingProcess = activeProcesses.find((p: any) => {
      const sameDevice = p.deviceId === formValues?.deviceId;
      const sameSite = p.siteId === formValues?.siteId;
      const sameZone = p.zoneId === targetZoneId;
      const sameTenant = p.tenantId === finalTenantId;
      
      return sameDevice && sameSite && sameZone && sameTenant;
    });

    // Block if the existing process is "Check Reference Stock" (regardless of how it was started)
    // Allow other processes (Edit Reference Stock, Set Reference Stock, etc.) to run without blocking
    if (existingProcess) {
      const isCheckReferenceStock = existingProcess.processName === 'Check Reference Stock' || 
                                    existingProcess.workflowName === 'Check Reference Stock';
      
      // Block if existing process is Check Reference Stock - prevent multiple Check Reference Stock processes
      if (isCheckReferenceStock) {
        setCanStartProcess(false); // Active Check Reference Stock process exists - cannot start
        console.error('ExecuteProcess: Cannot start process - Check Reference Stock process exists in active process table', {
          existingProcess: {
            processId: existingProcess.processId,
            processName: existingProcess.processName,
            deviceId: existingProcess.deviceId,
            siteId: existingProcess.siteId,
            zoneId: existingProcess.zoneId,
            tenantId: existingProcess.tenantId,
            state: existingProcess.isReadyForProcessing || 'unknown',
            startedViaStartButton: existingProcess.startedViaStartButton,
            userId: existingProcess.userId
          },
          attemptedProcess: {
            processId: selectedRow?.processId,
            deviceId: formValues?.deviceId,
            siteId: formValues?.siteId,
            zoneId: targetZoneId,
            tenantId: finalTenantId
          },
          note: 'Check Reference Stock process found in active process table - must be stopped before starting a new one.'
        });
        
        // Set flag to indicate we showed "already exists" error
        showedAlreadyExistsErrorRef.current = true;
        
        Modal.error({
          title: 'Process Already Running',
          content: 'Process is already running. Please stop it before starting a new one.',
          okText: 'OK',
          onOk: () => {
            // User acknowledged process already exists error
            // Close the device selection modal when user clicks OK on error modal
            setDeviceSelectModal(false);
            setCanStartProcess(null);
            form.resetFields();
            showedAlreadyExistsErrorRef.current = false; // Reset flag
          }
        });
        
        // DO NOT modify any state or dispatch any actions before returning
        // This ensures no cleanup or side effects occur when blocking the process
        return; // Stop execution - do not proceed with any state changes or API calls
      } else {
        // Other process types (Edit Reference Stock, Set Reference Stock, etc.) - allow to proceed
        // Existing process is not Check Reference Stock - allowing new process to start
        // Continue with process start - don't block
      }
    }
    
    // No active process found - set flag to allow starting
    setCanStartProcess(true); // No active process - can start (backend will clean up orphaned processes)
    
    // Only set state and proceed if validation passes
    if (selectedRow?.processId && formValues?.deviceId) {
      dispatch(setStopButtonForRun({ processId: selectedRow.processId, deviceId: formValues.deviceId, value: "start" }));
    }
    setDeviceInfo({ ...formValues, ...selectedRow, ...x, processName: selectedRow?.name });
    
    // No process found in active process table - allow starting new process
    // Before starting, refetch active processes to catch any newly created ones and clean them up
    // No process found in active process table - refetching to check for orphaned processes
    
    try {
      // Step 0: Refetch active processes to catch any orphaned processes that might exist
      // Refetching active processes to check for orphaned processes
      const refetchedData: any = await refetchActiveProcesses();
      const refetchedProcesses = refetchedData?.data?.result || [];
      
      // Refetch completed
      
      // Check if any process exists for the same device/site/zone combination
      const orphanedProcess = refetchedProcesses.find((p: any) => 
        p.deviceId === formValues?.deviceId &&
        p.siteId === formValues?.siteId &&
        p.zoneId === targetZoneId &&
        p.tenantId === finalTenantId &&
        p.processId === selectedRow?.processId
      );
      
      // If orphaned process found, stop it first before starting new one
      if (orphanedProcess) {
        // Found orphaned process, stopping it before starting new process
        
        try {
          await stopActiveProcess({
            processId: orphanedProcess.processId,
            deviceId: orphanedProcess.deviceId,
            userId: user?.userId,
            type: "stop",
            stopBy: "system",
            activity_Logs: false
          }).unwrap();
          
          // Successfully stopped orphaned process
          
          // Wait longer for the stop to complete and backend to clean up
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          // Refetch again to confirm the process is stopped
          const confirmRefetch: any = await refetchActiveProcesses();
          const confirmProcesses = confirmRefetch?.data?.result || [];
          const stillExists = confirmProcesses.find((p: any) => 
            p.processId === orphanedProcess.processId &&
            p.deviceId === formValues?.deviceId &&
            p.siteId === formValues?.siteId &&
            p.zoneId === targetZoneId &&
            p.tenantId === finalTenantId
          );
          
          if (stillExists) {
            console.warn('ExecuteProcess: Orphaned process still exists after stop, waiting longer...', {
              processId: orphanedProcess.processId
            });
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        } catch (stopError: any) {
          console.error('ExecuteProcess: Failed to stop orphaned process', {
            processId: orphanedProcess.processId,
            error: stopError?.data?.error?.message || stopError?.message,
            errorStatus: stopError?.status || stopError?.originalStatus
          });
          // Continue anyway - backend might handle it, but log the error
        }
      } else {
        // No orphaned process found after refetch - proceeding with executeProcess
      }
      
      // Step 1: Call executeProcess API
      // CRITICAL: Apply button should ONLY execute the process and set it to "ready" state
      // It should NOT auto-start the process - user must click Start button to begin execution
      // Backend should respect startedViaApplyButton flag and NOT stop processes in other sites/zones
      // The same processId can run simultaneously in different sites/zones/devices
      const applyPayload = {
        processId: selectedRow?.processId,
        userId: user?.userId,
        isPredefined: selectedRow?.isPredefined,
        deviceId: formValues?.deviceId,
        siteId: formValues?.siteId,
        zoneId: zone?.zoneId || formValues?.zoneId,
        startedViaApplyButton: true, // Flag to identify processes started via Apply button - backend should set state to "ready" only, not auto-start
        canStartProcess: canStartProcess, // Flag to indicate if process can start (true = no active process, backend should clean up orphaned)
      };
      
      console.log('[ExecuteProcess] Apply button - calling executeProcess (should NOT auto-start, only set to ready)', {
        payload: applyPayload,
        note: 'Backend should create state with isReadyForProcessing="ready" and NOT stop processes in other sites/zones'
      });
      
      // Calling executeProcess API
      
      let executeStateId: string | undefined;
      let executeWorkflowId: string | undefined;
      const readExecuteIds = (payload: any) => {
        const root = payload || {};
        const data = root?.data || {};
        const result = root?.result || data?.result || {};
        return {
          stateId: root?.stateId || data?.stateId || result?.stateId,
          workflowId: root?.workflowId || data?.workflowId || result?.workflowId,
        };
      };

      try {
        const executeResult = await executeProcess(applyPayload).unwrap();
        executeSucceededForCurrentModalRef.current = true;
        const ids = readExecuteIds(executeResult);
        executeStateId = ids?.stateId;
        executeWorkflowId = ids?.workflowId;
        // executeProcess API success
      } catch (executeError: any) {
        const errorStatus = executeError?.status || executeError?.originalStatus || executeError?.data?.statusCode;
        const errorMessage = executeError?.data?.error?.message || executeError?.data?.message || executeError?.message;
        
        // If we get a 409 Conflict, it means a process still exists - try to stop it and retry once
        if (errorStatus === 409 || errorStatus === 500) {
          // Received conflict/error, attempting to clean up and retry
          
          // Try one more refetch to find the process
          const finalRefetch: any = await refetchActiveProcesses();
          const finalProcesses = finalRefetch?.data?.result || [];
          const conflictingProcess = finalProcesses.find((p: any) => 
            p.deviceId === formValues?.deviceId &&
            p.siteId === formValues?.siteId &&
            p.zoneId === targetZoneId &&
            p.tenantId === finalTenantId &&
            p.processId === selectedRow?.processId
          );
          
          if (conflictingProcess) {
            // Found conflicting process in final refetch, stopping it
            
            try {
              await stopActiveProcess({
                processId: conflictingProcess.processId,
                deviceId: conflictingProcess.deviceId,
                userId: user?.userId,
                type: "stop",
                stopBy: "system",
                activity_Logs: false
              }).unwrap();
              
              // Successfully stopped conflicting process, waiting before retry
              
              // Wait for cleanup
              await new Promise(resolve => setTimeout(resolve, 1500));
              
              // Retry executeProcess once
              const retryPayload = {
                processId: selectedRow?.processId,
                userId: user?.userId,
                isPredefined: selectedRow?.isPredefined,
                deviceId: formValues?.deviceId,
                siteId: formValues?.siteId,
                zoneId: zone?.zoneId || formValues?.zoneId,
                startedViaApplyButton: true,
                canStartProcess: canStartProcess,
              };
              
              // Retrying executeProcess after cleanup
              
              const retryResult = await executeProcess(retryPayload).unwrap();
              executeSucceededForCurrentModalRef.current = true;
              const ids = readExecuteIds(retryResult);
              executeStateId = ids?.stateId;
              executeWorkflowId = ids?.workflowId;
              // executeProcess API succeeded after retry
            } catch (retryError: any) {
              console.error('ExecuteProcess: Retry failed after cleanup', retryError);
              throw retryError; // Re-throw to be handled by outer catch
            }
          } else {
            // Conflict error but process not found in active process query
            // Only show error if the error message indicates it's "Check Reference Stock"
            // Allow other processes (Set Reference Stock, Edit Reference Stock) to run without blocking
            const errorMsgLower = (errorMessage || '').toLowerCase();
            const isCheckReferenceStockError = errorMsgLower.includes('check reference stock');
            
            if (isCheckReferenceStockError) {
              // Only show error for Check Reference Stock processes
              console.error('ExecuteProcess: Conflict error for Check Reference Stock process', {
                errorStatus,
                errorMessage,
                note: 'Check Reference Stock process is running - blocking new process'
              });
              
              Modal.error({
                title: 'Process Already Running',
                content: 'Process is already running. Please stop it before starting a new one.',
                okText: 'OK',
                onOk: () => {
                  // User acknowledged Check Reference Stock conflict error
                  // Close the device selection modal
                  setDeviceSelectModal(false);
                  setCanStartProcess(null);
                  form.resetFields();
                }
              });
              
              // Don't throw error - we've shown the modal
              return; // Exit early
            } else {
              // Other process types (Set Reference Stock, Edit Reference Stock) - don't block, just log
              console.warn('ExecuteProcess: Conflict error for non-Check Reference Stock process - allowing to proceed', {
                errorStatus,
                errorMessage,
                note: 'Other process types (Set Reference Stock, Edit Reference Stock) are allowed to run - not blocking'
              });
              // Don't show error modal - allow the process to continue
              // The backend will handle the conflict appropriately
            }
          }
        } else {
          // Not a conflict/500 error, throw it
          throw executeError;
        }
      }
      
      // Step 2: Call stateCreation API after executeProcess succeeds
      // Calling stateCreation API
      // finalTenantId is already calculated at the beginning of handleApply
      
      if (!executeStateId) {
        message.error({
          content: "Process execution did not return stateId. Please try again.",
          key: "notificationKey",
          className: "errorMessage",
          duration: 3,
        });
        return;
      }

      await stateCreationMutation({
        ...formValues,
        zoneId: zone?.zoneId || formValues?.zoneId,
        userId: user.userId,
        userState: "login",
        tenantId: finalTenantId,
        processId: selectedRow?.processId,
        roleId: user?.roleId,
        stateId: executeStateId,
      }).unwrap();

      setDeviceInfo((prev: any) => ({
        ...prev,
        ...formValues,
        ...selectedRow,
        ...x,
        processName: selectedRow?.name,
        stateId: executeStateId,
        workflowId: executeWorkflowId,
      }));
      
      // Both APIs succeeded
      
    } catch (error: any) {
      // Error handling is done in the useEffect hooks for each mutation
      console.error('ExecuteProcess: Error in handleApply:', error);
      // The error will be caught by the respective mutation's error handler
    }
  };


  // Handle success for both APIs - navigate when stateCreation succeeds (executeProcess already succeeded)
  useEffect(() => {
    if (isStateCreationSuccess && setExecuteProcess?.isSuccess) {
      executeSucceededForCurrentModalRef.current = false;
      message.success({
        content: "Process executed and validated successfully. Ready to start process.",
        key: "notificationKey",
        className: "successMessage", 
        duration: 2 
      });
      navigate(Page.ACTIVITY_LOGS, { state: { data: deviceInfo, check: null } });
      // Reset the mutation state after success
      resetStateCreation();
      // Close the modal
      setDeviceSelectModal(false);
    }
  }, [isStateCreationSuccess, setExecuteProcess?.isSuccess, deviceInfo, navigate, resetStateCreation])

  useEffect(() => {
    if (isStateCreationError && stateCreationError) {
      const errorStatus = stateCreationError?.status || stateCreationError?.originalStatus || stateCreationError?.data?.statusCode;
      const errorMessage = stateCreationError?.data?.error?.message || stateCreationError?.data?.message || stateCreationError?.message;
      
      // Process state creation error detected

      // Provide user-friendly error message based on error type
      let userFriendlyMessage = errorMessage || "An error occurred during process validation";
      
      if (errorStatus === 404) {
        // 404 could mean endpoint not found or process state not found
        if (errorMessage?.toLowerCase().includes('process state not found') || 
            errorMessage?.toLowerCase().includes('execute the process first')) {
          userFriendlyMessage = "Process state not found. The process may need to be executed first. Please try selecting the process again and ensure all required fields are filled.";
        } else {
          userFriendlyMessage = "The process state endpoint was not found. Please contact support if this issue persists.";
        }
      } else if (errorStatus === 400) {
        userFriendlyMessage = errorMessage || "Invalid request. Please check that all required fields are filled correctly.";
      } else if (errorStatus === 500) {
        userFriendlyMessage = errorMessage || "Server error occurred. Please try again or contact support.";
      }

      dispatch(setProcessRunningModal({
        visible: true,
        processName: selectedRow?.name || "Process",
        deviceName: formValues?.deviceName || "Device",
        errorMessage: userFriendlyMessage
      }));

      // Reset the mutation state to prevent this useEffect from triggering again
      resetStateCreation();
    }
  }, [isStateCreationError, stateCreationError, dispatch, selectedRow?.name, selectedRow?.processId, formValues?.deviceName, formValues?.deviceId, resetStateCreation]);

  const onProcessRunningModalClose = () => {
    // ProcessRunningModal close requested

    dispatch(setProcessRunningModal({
      visible: false,
      processName: "",
      deviceName: "",
      errorMessage: ""
    }));
  };

  useEffect(() => {
    setExecuteTableData(getExecuteProcess?.data?.result);
  }, []);

  const columns = [
    {
      key: "tenantName",
      title: "Tenant",
      dataIndex: "tenantName",
      className: "executeProcessTable",
      sorter: true,
      ellipsis: true,
      width: "11%",
      render: (field: any, row: any) => {
        return (
          <div
            className="d-flex align-items-center"
            onClick={() => onRowClick(row)}
          >
            <p className="pl-10 tableData">{field}</p>
          </div>
        );
      },
    },
    {
      title: "Process Name",
      dataIndex: "name",
      sorter: true,
      className: "executeProcessTable",
      key: "name",
      ellipsis: true,
      width: "15%",
      render: (field: any, row: any) => {
        return (
          <div
            className="d-flex align-items-center"
            onClick={() => onRowClick(row)}
          >
            <p className="pl-10 tableData">{field}</p>
          </div>
        );
      },
    },

    {
      title: "DESCRIPTION",
      dataIndex: "description",
      key: "description",
      className: "executeProcessTable",
      width: "15%",
      sorter: true,
      render: (field: any, row: any) => {
        return (
          <div
            className="d-flex align-items-center"
            onClick={() => onPlayClick(row)}
          >
            <UITooltip title={row?.description} placement="top">
              <p className="pl-10 slice tableData">{field}</p>
            </UITooltip>
          </div>
        );
      },
    },
    {
      title: "LAST EXECUTED TIME",
      dataIndex: "lastExecutedTime",
      key: "lastExecutedTime",
      width: "20%",
      className: "executeProcessTable",
      sorter: true,
      ellipsis: true,
      render: (field: any, row: any) => {
        return (
          <div onClick={() => onRowClick(row)}>
            <span className="tableData">
              {row?.lastExecutedTime
                ? moment(row?.lastExecutedTime).format("DD MMM YYYY hh:mm A")
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataIndex: "login",
      width: "4%",
      key: "login",
      fixed: "right",
      render: (login: any, row: any) => {
        return (
          <div className="clickable" onClick={() => onPlayClick(row)}>
            <PlayIcon className="playbtn" />
          </div>
        );
      },
    },
  ];

  interface DataType {
    name: {
      first: string;
      last: string;
    };
    description: string;
    lastUpdated: string;
    createdAt: string;
  }
  interface Params {
    pagination?: TablePaginationConfig;
    sorter?: SorterResult<any> | SorterResult<any>[];
    total?: number;
    sortField?: string;
    sortOrder?: string;
  }
  useEffect(() => {
    setPagination({
      ...pagination,
      locale: { items_per_page: "" },
      total,
    });
  }, [total]);

  const fetchData = (params: Params = {}) => {
    setLoading(true);
    getExecuteProcess?.refetch();
    setSort({
      sortBy: params.sortField,
      sortOrder:
        params.sortOrder === "ascend"
          ? "1"
          : params.sortOrder === "descend"
          ? "-1"
          : undefined,
    });
    setPagination({
      ...params.pagination,
      locale: { items_per_page: "" },
      total,
    });
  };
  const handleTableChange = (
    newPagination: TablePaginationConfig,
    filters: Record<string, FilterValue>,
    sorter: SorterResult<DataType>
  ) => {
    fetchData({
      sortField: sorter.field as string,
      sortOrder: sorter.order as string,
      pagination: newPagination,
      ...filters,
    });
    setLoading(false);
  };

  return (
    <>
      <section className="listing-section">
        <Card className="uicard table uiinner-card">
          <div className="card-body">
            <UITable
              columns={columns}
              loading={loading}
              data={tableData}
              pagination={pagination}
              handleTableChange={handleTableChange}
              scroll={{ x: 1000, y: 500 }}
              rowSelection={onRowClick}
            />
          </div>
        </Card>
      </section>
      <UIConfirmModal
        key="selectSiteDevice"
        className="siteDeviceform"
        visible={deviceSelectModal}
        cancelSiteButton={onDeviceModalClose}
        cancelButton={ModalButton.CANCEL}
        confirmButton={ModalButton.APPLY}
        type={false}
        btnType="submit"
        form="selectSiteDevice"
      >
        <SiteDeviceForm
          id="selectSiteDevice"
          form={form}
          onModalSubmit={handleApply}
          siteOptions={getAllSiteOptions()}
          deviceOptions={getAllDeviceOptions()}
          zoneOptions={getZoneBySIteOptions()}
          zoneData={zone}
          setZoneData={setzone}
          formValues={formValues}
          setFormValues={setFormValues}
        />
      </UIConfirmModal>
      
      <ProcessRunningModal
        visible={processRunningModal?.visible || false}
        onClose={onProcessRunningModalClose}
        processName={processRunningModal?.processName || ""}
        deviceName={processRunningModal?.deviceName || ""}
        errorMessage={processRunningModal?.errorMessage || ""}
      />
    </>
  );
};
function stopProcess(arg0: {
  userId: any;
  stopBy: any;
  processName: any;
  activity_logs: boolean;
  processId: any;
  type: string;
  deviceId: any;
}) {
  throw new Error("Function not implemented.");
}
